import IndustrySolutionI18n from "@/components/landing/shared/IndustrySolutionI18n";
import { Clock, Bot, Wrench, BookOpen } from "lucide-react";
const LoesungSection = () => <IndustrySolutionI18n translationPrefix="industryMaschinenbau" icons={[Clock, Bot, Wrench, BookOpen]} />;
export default LoesungSection;
